import React from 'react';

import { oneOf, string } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { faBookOpen } from '@fortawesome/pro-regular-svg-icons/faBookOpen';

import Button from 'components/Common/Buttons/ButtonV3';
import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';
import TextToSpeechPlayAll from 'components/Common/LayoutV2/AppBar/TextToSpeech/components/TextToSpeechPlayAll';

import { TTS_PLAY_ALL } from 'modules/ElementaryCareers/constants';
import { SET_TTS_DATA } from 'modules/ElementaryCareers/store/actionTypes';

import s from './TextToSpeech.css';

const TextToSpeech = ({ variant, color }) => {
  const dispatch = useDispatch();
  const { ttsOption } = useSelector(state => state?.textToSpeech);

  const onClick = () => {
    const payload = {
      ttsOption: TTS_PLAY_ALL,
      playingItem: 0,
      isPlaying: false,
    };

    // Show TTS controls
    dispatch({
      type: SET_TTS_DATA,
      payload: {
        ttsOption: TTS_PLAY_ALL,
      },
    });

    // Start playing
    dispatch({
      type: SET_TTS_DATA,
      payload,
    });
  };

  if (ttsOption) {
    return (
      <div className={s.textToSpeechWrapper}>
        <TextToSpeechPlayAll variant={variant} />
      </div>
    );
  }

  return (
    <Button
      label="Read aloud"
      color={color}
      hasIconLeft
      variant="outlined"
      icon={<FontAwesomeIcon icon={faBookOpen} />}
      onClick={onClick}
      isElementary
    />
  );
};

TextToSpeech.propTypes = {
  variant: oneOf(['modal', 'page']),
  color: string,
};

TextToSpeech.defaultProps = {
  variant: 'page',
  color: undefined,
};

export default TextToSpeech;
